<template>
  <div>
    <el-popover
        ref="popover"
        placement="bottom"
        :width="displayWidth<400?300:400"
        trigger="click"
        v-model="popAdv"
        v-on:show="popState"
        v-on:hide="popState">
        <el-row class="divider">
          <el-col :span="6">
            <strong>Display Columns</strong>
          </el-col>
          <el-col :span="18">
            <el-checkbox-group v-model="checkedColsApply">
              <el-checkbox v-for="column in advColumns" :label="column.id" :key="column.id">{{column.label}}</el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
        <el-row class="divider">
          <el-col :span="6">
            <strong>Status</strong>
          </el-col>
          <el-col :span="18">
            <el-checkbox-group v-model="checkedStatusApply">
              <el-checkbox v-for="stat in advStatus" :label="stat.short" :key="stat.short">{{stat.label}}</el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
        <el-row class="advButtons">
          <el-col :span="8">
            <el-button type="text danger" size="mini" @click="resetFilters">Reset all filters</el-button>
          </el-col>
          <el-col :span="16">
            <el-button type="text" size="mini" class="right" @click="applyFilters">Apply</el-button>
            <el-button type="text info" size="mini" class="right" @click="cancelFilters">Cancel</el-button>
          </el-col>
        </el-row>
    </el-popover>

    <el-row :gutter="20" class="no-print">
      <el-col :xs="24" :sm="15" :md="16">
        <!-- <el-input placeholder="Search" v-model="searchq" clearable class="input-with-select hidden-sm-and-up">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
          <el-select slot="prepend" v-model="quarter" value-key="quarter" @change="updateQuarter(quarter, department, subject)" placeholder="Select">
            <el-option v-for="term in terms" :label="term.description" :value="term.code" :key="term.code"></el-option>
          </el-select>
        </el-input> -->
        <!-- class="input-with-select hidden-xs-only" -->
        <label for="quarterDropdown" style="display:none;">Select Quarter</label>
        <label for="searchSchedule" style="display:none;">Search Schedule</label>
        <el-input placeholder="Search Schedule" id="searchSchedule" v-model="searchq" clearable class="input-with-select">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-select slot="prepend" v-model="quarter" value-key="quarter" @change="updateQuarter(quarter, department, subject)" placeholder="Select" id="quarterDropdown">
              <el-option v-for="term in terms" :label="term.description" :value="term.code" :key="term.code"></el-option>
            </el-select>
          <!-- <el-tooltip content="Filter Options" placement="top" slot="append">
            <el-button v-popover:popover  :class="{'pop-active': isPopActive, 'filter-active': isFilter}"><fa icon="filter" fixed-width/> <span class="hidden-sm-and-down">Filter</span></el-button>
          </el-tooltip> -->
        </el-input>

      </el-col>

      <el-col :xs="24" :sm="9" :md="8">
        <label for="copyUrl" style="display:none;">Copy URL</label>
        <label for="downloadCsv" style="display:none;">Download CSV</label>
        <el-button-group class="right right-btn">
          <!-- <el-tooltip content="Filter" placement="top" class="hidden-sm-and-up">
            <el-button v-popover:popover  :class="{'pop-active': isPopActive, 'filter-active': isFilter}"><fa icon="filter" fixed-width/></el-button>
          </el-tooltip> -->
          <el-tooltip content="Filter Options" placement="top">
            <el-button v-popover:popover  :class="{'pop-active': isPopActive, 'filter-active': isFilter}"><fa icon="filter" fixed-width/> <span class="hidden-sm-only">Filter</span></el-button>
          </el-tooltip>
          <el-tooltip content="Copy URL" placement="top">
            <el-button @click="copyUrl" id="copyUrl"><fa icon="clipboard" fixed-width/></el-button>
          </el-tooltip>
          <!-- <el-tooltip content="Email URL" placement="top">
            <el-button @click="emailUrl"><fa icon="envelope" fixed-width/></el-button>
          </el-tooltip> -->
          <el-tooltip content="Download CSV" placement="top">
            <download-csv
              class   = "el-button"
              :data   = "csvList"
              :name   = "pageTitle">
              <el-button id="downloadCsv"><fa icon="file-download" fixed-width/></el-button>
            </download-csv>
          </el-tooltip>
        </el-button-group>
      </el-col>
    </el-row>
    <div class="print-only">
      <h4>{{getTermName(term)}} </h4>
    </div>

    <el-row :gutter="20" class="display-key no-print">
      <el-col :span="12"><div>Displaying <strong>{{coursesList.length}}</strong> classes</div>
      </el-col>
      <el-col :span="12"><div class="right"><div class="open"></div>Open <div class="closed"></div>Closed <div class="waitlist"></div>Closed w/ Wait List</div>
      </el-col>
    </el-row>

    <el-table
      :data="coursesList"
      style="width: 100%"
      :default-sort = "{prop: 'catalog_nbr', order: 'ascending'}"
      empty-text="No classes found"
      v-loading="loading">

      <el-table-column :fixed="col.fixed" :prop="col.prop" :label="col.label" :min-width="col.width" v-for="col in columnsList" :sortable="col.sortable" :sort-method="(a, b) => sortData(a, b, col.prop)" :key="col.prop">
        <template slot-scope="scope">
          <span v-if="col.prop === 'course_status'" :class="displayStatus(scope.row.enrl_status)"></span>
          <router-link v-if="col.prop === 'title'" :class="{cancelled: scope.row.meeting_days==='Cancelled'}" :to="{ name: 'course', params: { term: scope.row.strm, course: scope.row.class_nbr, title: slug(scope.row.title) }}">{{scope.row.title}}</router-link>
          <span v-else-if="col.prop === 'enrl_total' && scope.row.enrl_capacity && scope.row.enrl_total" class="seats">
            <span v-if="scope.row.waitlist_total > 0" class="available">{{scope.row.waitlist_total}} waiting</span><span v-else-if="scope.row.enrl_capacity - scope.row.enrl_total < 0" class="available">0 open</span><span class="available" v-else="scope.row.enrl_capacity - scope.row.enrl_total">{{scope.row.enrl_capacity - scope.row.enrl_total}} open</span> / {{scope.row.enrl_capacity}} total</span>
          <span v-else-if="col.prop === 'meeting_days'">{{scope.row.meeting_days}}</span>
          <span v-else-if="col.prop === 'start_time'">{{formatTime(scope.row.start_time, scope.row.end_time)}}</span>
          <span v-else-if="col.prop === 'catalog_nbr'">{{scope.row.subject}}-{{scope.row.catalog_nbr}}</span>
          <span v-else-if="col.prop === 'location'">{{scope.row.location}}</span>
          <span v-else-if="col.prop === 'enrollment'">{{scope.row.enrl_total}}</span>
          <span v-else-if="col.prop === 'instructors[0].name'">
            <router-link v-if="scope.row.instructors[0].cruzid" :to="{ name: 'teacher', params: { uid: scope.row.instructors[0].cruzid }}">{{scope.row.instructors[0].name}}</router-link>
            <span v-else>{{scope.row.instructors[0].name}}</span>
          </span>
          <span v-else-if="col.prop === 'class_nbr'">{{scope.row.class_nbr}}</span>
        </template>
      </el-table-column>


      <!-- <el-table-column :fixed="false" prop="title" label="Title" :min-width="200" sortable :sort-method="test">
        <template slot-scope="scope">
          <router-link :class="{cancelled: scope.row.meeting_days==='Cancelled'}" :to="{ name: 'course', params: { term: scope.row.strm, course: scope.row.class_nbr, title: slug(scope.row.title) }}">{{scope.row.title}}</router-link>
        </template>
      </el-table-column> -->


    </el-table>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  middleware: 'load-courses',
  layout: 'basic',

  metaInfo () {
    return { title: 'Class Schedule', titleTemplate: null }
  },

  data: () => ({
    title: 'Class Schedule',
    pageTitle: 'ClassSchedule.csv',
    searchq: '',
    quarter: null,
    isPopActive: false,
    isFilter: true,
    popAdv: false,
    displayWidth: null,
    // isLoaded: false,
    advColumns: [],
    checkedCols: [2,3,4],
    checkedColsApply: [],
    advStatus: [],
    checkedStatus: ["o","c","w"],
    checkedStatusApply: [],
    loading: false,
    status: [
      {
        id: 1,
        label: "Open",
        short: "o",
        display: true
      },
      {
        id: 2,
        label: "Closed",
        short: "c",
        display: true
      },
      {
        id: 3,
        label: "Wait List",
        short: "w",
        display: true
      }
    ],
    columns: [
      {
        id: 0,
        prop:"course_status",
        label: "",
        width: "30",
        fixed: false,
        display: false,
        sortable: false,
        sort: ""
      },
      {
        id: 1,
        prop:"catalog_nbr",
        label: "Course ID",
        width: "108",
        fixed: false,
        display: false,
        sortable: true,
        sort: ""
      },
      {
        id: 2,
        prop:"title",
        label: "Title",
        width: "175",
        fixed: false,
        display: false,
        sortable: true,
        sort: ""
      },
      {
        id: 3,
        prop:"enrl_total",
        label: "Seats",
        width: "145",
        fixed: false,
        display: true,
        sortable: true,
        sort: ""
      },
      {
        id: 4,
        prop:"meeting_days",
        label: "Days",
        width: "80",
        fixed: false,
        display: true,
        sortable: true,
        sort: ""
      },
      {
        id: 5,
        prop:"start_time",
        label: "Time",
        width: "150",
        fixed: false,
        display: true,
        sortable: true,
        sort: "sortTime"
      },
      {
        id: 6,
        prop:"location",
        label: "Location",
        width: "140",
        fixed: false,
        display: true,
        sortable: true,
        sort: ""
      },
      {
        id: 7,
        prop:"instructors[0].name",
        label: "Instructor",
        width: "120",
        fixed: false,
        display: true,
        sortable: true,
        sort: ""
      },
      {
        id: 8,
        prop:"class_nbr",
        label: "Class #",
        width: "90",
        fixed: false,
        display: true,
        sortable: true,
        sort: ""
      },
      {
        id: 9,
        prop:"enrollment",
        label: "Enrollment",
        width: "120",
        fixed: false,
        display: true,
        sortable: true,
        sort: ""
      }
    ],
  }),

  watch: {
    searchq (value) {
      this.setQuery({q:value},{type:"replace"})
    }
  },

  created() {
    // console.log(this.department)
    // console.log(this.term)
    // console.log(this.courses)
    // if(this.courses) {
    //   this.loading = false
    // }

    if(this.offline) {
      this.$alert('The Class Schedule is currently offline.', 'Offline', {
        confirmButtonText: 'Dismiss'
      })
    }

    // find out user's screen size
    this.displayWidth = window.innerWidth
      || document.documentElement.clientWidth
      || document.body.clientWidth
      window.screen.width

    if(this.$route.query.q) {
      this.searchq = this.$route.query.q.replace(/%20/g, ' ')
    }

    this.quarter = this.term
    if(this.subject) {
      this.setQuery({sub:this.subject},{type:"replace"})
      this.pageTitle = this.subject + ' ' + this.getTermName(this.term) + ".csv";
    }
    if(this.department) {
      this.setQuery({d:this.department},{type:"replace"})
      this.pageTitle = this.department + ' ' + this.getTermName(this.term) + ".csv";
    }
    // this.isLoaded = true
    this.advColumns = this.columns.filter(function(c) {
      return c.display
    })
    this.checkedColsApply = this.checkedCols
    if(this.$route.query.c) {
      this.checkedCols = this.$route.query.c.split('-').map(Number)
      this.checkedColsApply = this.checkedCols
    }
    this.advStatus = this.status.filter(function(s) {
      return s.display
    })
    this.checkedStatusApply = this.checkedStatus
    if(this.$route.query.s) {
      this.checkedStatus = this.$route.query.s.split('-')
      this.checkedStatusApply = this.checkedStatus
    }
  },

  computed: {
    ...mapGetters({
      term: 'courses/term',
      terms: 'courses/terms',
      courses: 'courses/courses',
      department: 'courses/department',
      subject: 'courses/subject',
      offline: 'courses/offline'
    }),

    search: {
      get () {
        if(this.$route.query.q) {
          this.searchq = this.$route.query.q.replace(/%20/g, ' ')
          return this.$route.query.q
        } else {
          return ''
        }
      },
      set (value) {
        this.searchq = value
        this.setQuery({q:value},{type:"replace"})
      }
    },

    statusList () {
      this.coursesList = this.coursesList.filter(c => ["Open", "Closed", "Wait List"].includes(c.enrl_status))
    },

    columnsList () {
      return this.columns.filter(c => this.checkedCols.includes(c.id) || c.id === 1 || c.id === 0)
    },

    coursesList () {
      const status = this.status.filter(s => {
        return this.checkedStatus.includes(s.short)
      }).map(st => st.label.toLowerCase())

      const courses = this.courses.filter(c => {
        return status.includes(c.enrl_status.toLowerCase())
      })

      return courses.filter(course => {
        return  course.title.toLowerCase().includes(this.searchq.toLowerCase()) ||
                course.location.toLowerCase().includes(this.searchq.toLowerCase()) ||
                course.instructors[0].name.toLowerCase().includes(this.searchq.toLowerCase()) ||
                course.instructors[0].cruzid.toLowerCase().includes(this.searchq.toLowerCase()) ||
                course.enrl_status.toLowerCase().includes(this.searchq.toLowerCase()) ||
                course.class_nbr.toLowerCase().includes(this.searchq.toLowerCase()) ||
                course.catalog_nbr.toLowerCase().includes(this.searchq.toLowerCase()) ||
                course.title.toLowerCase().includes(this.searchq.toLowerCase())
      })
    },

    labels () {
      var data = {};
      var cols = this.columns;
      for (var col in cols){
        data[cols[col].prop] = cols[col].label;
      }
      return data;
    },

    fields () {
      var data = [];
      var cols = this.columnsList;
      for (var col in cols){
       data.push(cols[col].prop);
      }
      return data;
    },

    csvList () {
      var data = this.coursesList;
      var cols = this.columnsList;
      var returnData = [];
      var colName = '';
      for (var rowKey in data){
         returnData[rowKey] = {};
        for (var col in cols){
          if (cols[col].prop == "course_status"){
            returnData[rowKey]['status'] =  data[rowKey]['enrl_status'];
          } else if (cols[col].prop == "catalog_nbr"){
            returnData[rowKey][cols[col].label] = data[rowKey]['subject'] + '-' + data[rowKey]['catalog_nbr'];
          } else if (cols[col].prop == "start_time"){
            returnData[rowKey][cols[col].label] = this.formatTime(data[rowKey]['start_time'], data[rowKey]['end_time']);
          } else if (cols[col].prop == "instructors[0].name"){
            returnData[rowKey][cols[col].label] = data[rowKey].instructors[0].name;
          } else if (cols[col].prop == "enrollment"){
            returnData[rowKey][cols[col].label] = data[rowKey]['enrl_total'];
          } else if (cols[col].prop == "enrl_total"){
            returnData[rowKey][cols[col].label] = (data[rowKey]['enrl_capacity']-data[rowKey]['enrl_total'])<0?0:data[rowKey]['enrl_capacity']-data[rowKey]['enrl_total'];
          } else {
            returnData[rowKey][cols[col].label] =  data[rowKey][cols[col].prop];
          }
        }
      }
      return returnData;
    },

  },

  methods: {

    sortData(a, b, key) {
      if(key==='catalog_nbr') {
        if(a.subject === b.subject) {
          // return parseInt(a[key], 10) === parseInt(b[key], 10) ? 0 : parseInt(a[key], 10) > parseInt(b[key], 10) ? 1 : -1
          return a[key].localeCompare(b[key], 'en', { numeric: true })
        } else {
          return a.subject > b.subject ? 1 : -1
        }
      } else if(key==='start_time') {
        return parseFloat(a[key]) > parseFloat(b[key]) ? 1 : -1
      } else if(key==='meeting_days') {
        var daysort = {
          "su": 0,
          "m": 1,
          "mw": 2,
          "mwf": 3,
          "mtuwthf": 4,
          "tu": 5,
          "tuth": 6,
          "w": 7,
          "th": 8,
          "f": 9,
          "sa": 10,
          "tba": 11,
          "cancelled": 12
        }
        var day1 = a.meeting_days.toLowerCase()
        var day2 = b.meeting_days.toLowerCase()
        return daysort[day1] > daysort[day2] ? 1 : -1
      } else if(key==='enrollment') {
        return Number(a.enrl_total) > Number(b.enrl_total) ? 1 : -1
      } else if(key==='enrl_total') {
        var xa = ""
        if(a.waitlist_total > 0) {
          xa = -a.waitlist_total
        } else if((a.enrl_capacity - a.enrl_total) < 0) {
          xa=0
        } else {
          xa = (a.enrl_capacity - a.enrl_total)
        }
        var xb = ""
        if(b.waitlist_total > 0) {
          xb = -b.waitlist_total
        } else if((b.enrl_capacity - b.enrl_total) < 0) {
          xb=0
        } else {
          xb = (b.enrl_capacity - b.enrl_total)
        }
        return xa < xb ? 1 : xa > xb ? -1 : 0
      } else if(key==='instructors[0].name') {
        return a.instructors[0].name > b.instructors[0].name ? 1 : -1
      } else {
        return a[key] > b[key] ? 1 : -1
      }
    },

    applyFilters () {
      const cols = this.checkedColsApply.join('-')
      this.setQuery({c:cols},{type:"replace"})
      this.checkedCols = this.checkedColsApply

      const stat = this.checkedStatusApply.join('-')
      this.setQuery({s:stat},{type:"replace"})
      this.checkedStatus = this.checkedStatusApply

      this.popAdv = false
    },

    cancelFilters () {
      this.popAdv=false
      this.checkedColsApply = this.checkedCols
      this.checkedStatusApply = this.checkedStatus
    },

    resetFilters () {
      this.checkedColsApply=[2,3,4]
      this.checkedStatusApply=["o","c","w"]
    },

    displayStatus (status) {
      if(status.search(/wait/i) != -1) {
        status = 'waitlist'
      } else if(status.search(/closed/i) != -1) {
        status = 'closed'
      } else {
        status = 'open'
      }
      return status
    },

    formatter (row, column) {
      // return row.address;
      if(column.property === 'title') {
        // console.log(row)
        return row.title
      }
    },

    formatTime (start, end) {
      if(start == "TBA" || end == "TBA") {
        return "TBA"
      } else {
        return new Date("2001/1/1 " + start).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) + ' - ' +  new Date("2001/1/1 " + end).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
      }
    },

    copyUrl () {
      var url = window.location.href
      this.$copyText(url)
      this.$message({
        showClose: true,
        dangerouslyUseHTMLString: true,
        message: '<strong style="color:black;">Copied </strong><i>'+url+'</i>'
      })
    },

    updateCols (value) {
      const cols = value.join('-')
      this.setQuery({c:cols},{type:"replace"})
    },

    updateStatus (value) {
      const stat = value.join('-')
      this.setQuery({s:stat},{type:"replace"})
    },

    emailUrl () {
      var url = window.location.href
      window.location.href = 'mailto:?subject=Class Schedule: '+this.department+' '+this.quarter+'&body='+url
    },

    async updateQuarter (term, department, subject) {
      this.loading = true
      // const { data } = await axios.get('/api/courses')
      // const { data } = await axios.get('https://webapps-dev.ucsc.edu/wcsi/api/courses')
      // const { data } = await axios.get('https://my.dev.ais.aws.ucsc.edu/PSIGW/RESTListeningConnector/PSFT_CSDEV/SCX_CLASS_LIST.v1/'+term+'?dept='+department)
      var qs = ''
      if(subject) {
        qs = 'subject='+subject
        if(department) {
          qs += '&'
        }
      }
      if(department) {
        qs = 'dept='+department
      }
      try {
        const { data } = await axios.get('https://my.ucsc.edu/PSIGW/RESTListeningConnector/PSFT_CSPRD/SCX_CLASS_LIST.v1/'+term+'?'+qs)
        this.$store.dispatch('courses/updateCourses', { courses: data.classes })
      } catch (e) {
        this.$store.dispatch('courses/updateCourses', { courses: [] })
      }
      this.setQuery({t:term},{type:"replace"})
      this.loading = false
    },

    popState: function(){
      this.isPopActive = !this.isPopActive
      if(this.isPopActive) {
        $('.input-with-select .el-input-group__append').addClass('pop-active')
      } else {
        $('.input-with-select .el-input-group__append').removeClass('pop-active')
      }
      this.checkedColsApply = this.checkedCols
      this.checkedStatusApply = this.checkedStatus
    },

    slug: function(title) {
      var slug = ""
      // Change to lower case
      var titleLower = title.toLowerCase()
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e')
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a')
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o')
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u')
      // Letter "d"
      slug = slug.replace(/đ/gi, 'd')
      // Remove invalid characters
      slug = slug.replace(/[^a-z0-9 -]/g, '')
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, '')
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, '-')

      return slug
    },

    setQuery: function (key, value, options) {
      var baseUrl         = [location.protocol, '//', location.host, location.pathname].join(''),
          q               = document.location.search,
          changes         = {},
          aType           = typeof(key),
          clear           = false;

      if(aType == "string"){
          changes[key] = value;
      }else if(aType == "object"){
          changes = key;
          options = value;
      }else if(key === false){
          clear = true;
      }

      //Options
      if(!options) options = {};
      var historyType     = options.type ? options.type : "push",
          state           = options.state ? options.state : {},
          title           = options.title ? options.title : "";

      if(clear){
          q = "";
      }else{
          var escapeRegExp = function(string){ return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')};
          for (var key in changes) {
              var value       = changes[key];
              var newParam    = key + '=' + encodeURIComponent(value);
              var updateRegex = new RegExp('([\?&])' + escapeRegExp(key) + '[^&]*');
              var removeRegex = new RegExp('([\?&])' + escapeRegExp(key) + '=[^&;]+[&;]?');

              if( typeof value == 'undefined' || value == null || value == '' ) { // Remove param if value is empty
                  q = q.replace(removeRegex, "$1");
                  q = q.replace( /[&;]$/, "" );
              } else if (q.match(updateRegex) !== null) { // If param exists already, update it
                  q = q.replace(updateRegex, "$1" + newParam);
              } else { // Otherwise, add it to end of query string
                  var join = q ? "&" : "?";
                  q = q + join + newParam;
              }

          }
      }

      if(q == "?") q = "";
      window.history[historyType+"State"](state, title, baseUrl + q);

      return !!q; //Return true if there's a query string, false otherwise
    },
    getTermName (term) {
      var qtrs = {0: "Winter", 2:"Spring", 4:"Summer", 6:"Summer", 8:"Fall"};
      return qtrs[term.substring(3)] + " 20" + term.substring(1,3);
    },
  }
}
</script>

<style lang="scss">
  .danger {
    color: #F56C6C !important;
  }

  .info {
    color: #909399 !important;
  }

  .cancelled {
    text-decoration:line-through;
  }

  .right-btn {
    padding-left: 0 !important;
    margin-left: 0 !important;
  }

  .advButtons {
    padding: 6px 15px !important;

    .el-button:last-child {
      margin-right: 10px !important;
    }

    button:hover {
    opacity: 0.8;
  }
  }

  .el-select .el-input {
    width: 200px;
  }

  input::placeholder {
    color: #bbb !important;
  }

  .display-key {
    background-color: #f8f8f8;
    margin: 0 !important;
    font-size: 13px;
    padding: 10px 5px 0;
    color: #666;
  }

  .closed {
    width: 10px;
    height: 10px;
    background: red;
    display: inline-block;
  }

  .open {
    width: 10px;
    height: 10px;
    background: green;
    border-radius: 50%;
    display: inline-block;
  }

  .waitlist {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 12px solid #FAC509;
    display: inline-block;
  }

  .open, .closed, .waitlist {
    margin: 0 5px;
  }

  .input-with-select .el-input-group__prepend, .input-with-select .el-input-group__append {
    background-color: #fff;
  }

  .input-with-select .el-input-group__append:hover, .input-with-select .el-input-group__append:focus, .input-with-select .pop-active {
    color: #409EFF;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }

  .filter-active {
    color: #409EFF !important;
  }

  .el-table {
    thead {
      color: #73777D !important;
      font-weight: 500;
    }

    .cell {
      word-break: keep-all !important;
    }

    .el-loading-spinner {
      top: 100px;
    }

  }


// start scrollbar
  // .el-table__header-wrapper, .el-table__body-wrapper {
  //   overflow: auto !important;
  // }
// end scrollbar


  .el-input__icon {
    color: #999 !important;
  }

  .el-input__inner {
    color: #666 !important;
  }

  .el-select-dropdown__item {
    margin: 0 0 0.45em 0;
  }

  .el-input-group__prepend {
    // padding: 0 20px 0 10px !important;
    // margin: 0 !important;
    margin-left: 0 !important;
    text-align: left;
    padding-left: 0 !important;
    // padding: 0 !important;
  }

  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

  .right {
    text-align: right;
    // float: right;
  }

  .el-button {
    .el-button {
      padding: 0;
      margin: 0;
      border: none;
      background-color: transparent;
    }
  }

  .el-input__icon, .el-input__prefix {
    transition: none !important;
  }

  *:focus {
    outline: none;
  }

  .el-popover {
    padding: 0 !important;

    .el-row {
      padding: 14px 15px;


    }

    .divider {
      border-bottom: 1px #eee solid;
    }

    .el-checkbox-group {
      .el-checkbox {
        width: 90px;
        padding-bottom: 10px;
      }

      .el-checkbox + .el-checkbox {
        margin-left: 0px;
        // margin-bottom: 10px;
        // padding: 10px 0;
      }

      .el-checkbox:nth-last-child(-n+3) {
        padding-bottom: 0;
      }
    }


  }

  table {
    margin: 0;
    padding: 0;
  }

  .seats {
    font-size: 80%;
    color: #888;
    .available {
      color: #606266;
      font-size: 125%;
      padding-right: 3px;
    }
  }

  div.print-only{
    display: none;
  }

  #wcsi div.cell{
    padding: 4px 5px;
  }

@media print {
  html, body{
    width: auto;
    height: auto;
  }
  body {
    overflow: auto;
    height: auto;
    margin: 0 !important;
    -webkit-print-color-adjust: exact !important;
  }
  .scroll-y {
     height: auto;
     overflow: visible;
  }
  @page {
    size: landscape;
    margin-top: 0.35in;
    margin-left: 0.30in;
    margin-right: 0.30in;
    margin-bottom: 0.35in;
  }

  div.row > div {
    display: inline-block;
    border: solid 1px #ccc;
    margin: 0.2cm;
  }
  div.row {
    display: block;
  }

  table {
    font-size: 100%;
  }
  div.no-print, div.contentBox, div.breadcrumbs, .site-header, .sidebar, .main-footer {
    display: none;
  }
  div.print-only{
    display: block;
  }
  #wcsi .el-table td, #wcsi .el-table th, div.cell {
      padding: 0;
  }
  .el-table span.caret-wrapper{
    display: none;
  }
  #wrap, #container, #content, #sprflt, #main, .sidebar {
    border: none !important;
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
  }
  #wcsi .el-table td .closed {
    width: 10px !important;
    height: 10px !important;
    background: red !important;
    display: inline-block !important;
  }

  #wcsi .el-table td div.cell span.open {
    height: 10px !important;
    background: green !important;
    border-radius: 50% !important;
    display: inline-block !important;
  }
  #wcsi table.el-table__body {
    table-layout: auto;
  }
  #wcsi div.el-table{
    zoom: 92%;
  }
  #wcsi div.el-table__body-wrapper{
     overflow: hidden;
  }

}
</style>



// WEBPACK FOOTER //
// resources/js/pages/courses.vue